import React, { useEffect, useState } from "react";
import { Typography, TextField, InputAdornment } from "@mui/material";
import { useSelector,useDispatch } from "react-redux";
import {adduser, edituser} from "../../Restclient/datacollection";
import {updateuserslist} from "../../store/cofig_data";

export default function Adduser (props) {
    const dispatch = useDispatch()
    const userlist = useSelector((state) => state.configdata.userslist)

    const [username, setUsername] = useState("")
    const [email, setEmail] = useState("")
    const [mobile, setMobile] = useState("")
    const [place, setPlace] = useState("")
    const [state, setState] = useState("")
    const [country, setCountry] = useState("")
    const [pin, setPin] = useState("")
    const [discription, setDiscription] = useState("")
    const [userGroup, setUsergroup] = useState("")
    const [userpermission, setUserpermission] = useState("")
    const [showmsg, setShowmsg] = useState(false)
    const [msg, setMsg] = useState("")
    const [msgcolor, setMsgcolor] = useState(false)

    const handleusernamechange = (e) => {
        setUsername(e.target.value)
        if(showmsg) {
            setShowmsg(false)
        }
    }

    const handleemailchange = (e) => {
        setEmail(e.target.value)
        if(showmsg) {
            setShowmsg(false)
        }
    }

    const handlemobilechnage = (e) => {
        setMobile(e.target.value)
        if(showmsg) {
            setShowmsg(false)
        }
    }

    const handleplacechange = (e) => {
        setPlace(e.target.value)
        if(showmsg) {
            setShowmsg(false)
        }
    }

    const handlestatechange = (e) => {
        setState(e.target.value)
        if(showmsg) {
            setShowmsg(false)
        }
    }

    const handlecountrychange = (e) => {
        setCountry(e.target.value)
        if(showmsg) {
            setShowmsg(false)
        }
    }

    const handlepinchange = (e) => {
        setPin(e.target.value)
        if(showmsg) {
            setShowmsg(false)
        }
    }

    const handlediscriptionchane = (e) => {
        setDiscription(e.target.value)
        if(showmsg) {
            setShowmsg(false)
        }
    }

    const handleusergroupchange = (e) => {
        setUsergroup(e.target.value)
        if(showmsg) {
            setShowmsg(false)
        }
    }

    const handleuserpermissionchange = (e) => {
        setUserpermission(e.target.value)
        if(showmsg) {
            setShowmsg(false)
        }
    }

    const savecallback = (result) => {
        console.log("add user result ",result)
        
        if(result.status) {
            if(props.data.request === "add") {
                dispatch(updateuserslist(result.data.users.data))
                setMsg("User data added")
                setShowmsg(true)
                setMsgcolor(true)
                setUsername("")
                setEmail("")
                setMobile("")
                setPlace("")
                setState("")
                setPin("")
                setCountry("")
                setDiscription("")
                setUsergroup("")
                setUserpermission("")
            } else if(props.data.request === "edit") {
                dispatch(updateuserslist(result.data.users.data))
                setMsg("User data updated")
                setShowmsg(true)
                setMsgcolor(true)
            }
        } else {
            if(props.data.request === "add") {
                setMsg("User data not added")
                setShowmsg(true)
                setMsgcolor(false)
            } else if(props.data.request === "edit") {
                setMsg("User data not updated")
                setShowmsg(true)
                setMsgcolor(false)
            }
        }
    }

    useEffect(() => {
        console.log("props.data ",props.data, userlist)
        if(props.savetrigger) {
            if(props.data.request === "add") {
                if(props.data.data.type === "Organization") {
                    if(username === "") {
                        setMsg("Please provide user Name")
                        setShowmsg(true)
                        setMsgcolor(false)
                        props.callbacksave()
                        return
                    }
                    if(email === "") {
                        setMsg("Please provide email")
                        setShowmsg(true)
                        setMsgcolor(false)
                        props.callbacksave()
                        return
                    }

                    for(let i=0; i<userlist.length; i++) {
                        if(username === userlist[i].UserName) {
                            setMsg("This user name exist in Organization")
                            setShowmsg(true)
                            setMsgcolor(false)
                            props.callbacksave()
                            return
                        }
                        if(email === userlist[i].Email) {
                            setMsg("This email exist in Organization")
                            setShowmsg(true)
                            setMsgcolor(false)
                            props.callbacksave()
                            return
                        }
                    }

                    var usedatails={
                        "UserName": username,
                        "Email": email,
                        "Mobile": mobile,
                        "Address": place+";"+state+";"+country+";"+pin,
                        "Discription": discription,
                        "State": true,
                        "Permission": userpermission,
                        "Groupname": userGroup,
                        "Orgname": props.data.data.orgpro.data.Organizationname,
                        "Project": "All"
                    }
                    adduser(usedatails, savecallback)

                } else if(props.data.data.type === "Project") {
                    if(username === "") {
                        setMsg("Please provide user Name")
                        setShowmsg(true)
                        setMsgcolor(false)
                        props.callbacksave()
                        return
                    }
                    if(email === "") {
                        setMsg("Please provide email")
                        setShowmsg(true)
                        setMsgcolor(false)
                        props.callbacksave()
                        return
                    }

                    for(let i=0; i<userlist.length; i++) {
                        if(username === userlist[i].UserName) {
                            setMsg("This user name exist in Organization")
                            setShowmsg(true)
                            setMsgcolor(false)
                            props.callbacksave()
                            return
                        }
                        if(email === userlist[i].Email) {
                            setMsg("This email exist in Organization")
                            setShowmsg(true)
                            setMsgcolor(false)
                            props.callbacksave()
                            return
                        }
                    }

                    var usedatails={
                        "UserName": username,
                        "Email": email,
                        "Mobile": mobile,
                        "Address": place+";"+state+";"+country+";"+pin,
                        "Discription": discription,
                        "State": true,
                        "Permission": userpermission,
                        "Groupname": userGroup,
                        "Orgname": props.data.data.orgpro.orgname,
                        "Project": props.data.data.orgpro.data.Projectname
                    }
                    adduser(usedatails, savecallback)

                }
            } else if(props.data.request === "edit") {
                if(props.data.data.type === "Organization") {
                    var usedatails={
                        "UserName": username,
                        "Email": email,
                        "Mobile": mobile,
                        "Address": place+";"+state+";"+country+";"+pin,
                        "Discription": discription,
                        "State": true,
                        "Permission": userpermission,
                        "Groupname": userGroup,
                        "Orgname": props.data.data.orgpro.data.Organizationname,
                        "Project": "All"
                    }
                    edituser(usedatails, savecallback)
                } else if(props.data.data.type === "Project") {
                    var usedatails={
                        "UserName": username,
                        "Email": email,
                        "Mobile": mobile,
                        "Address": place+";"+state+";"+country+";"+pin,
                        "Discription": discription,
                        "State": true,
                        "Permission": userpermission,
                        "Groupname": userGroup,
                        "Orgname": props.data.data.orgpro.orgname,
                        "Project": props.data.data.orgpro.data.Projectname
                    }
                    edituser(usedatails, savecallback)
                }
            }    
        }
        props.callbacksave()
    },[props.savetrigger])

    useEffect(() => {
        console.log("user edit ",props.data)
        if(props.data.request === "edit") {
            console.log("edit user ",props.data.data.userdata)
            setUsername(props.data.data.userdata.UserName)
            setEmail(props.data.data.userdata.Email)
            setMobile(props.data.data.userdata.Mobile)
            var splitaddress = props.data.data.userdata.Address.split(";")
            setPlace(splitaddress[0])
            setState(splitaddress[1])
            setCountry(splitaddress[2])
            setPin(splitaddress[3])
            setDiscription(props.data.data.userdata.Discription)
            setUsergroup(props.data.data.userdata.Groupid)
            setUserpermission(props.data.data.userdata.Permission)
        }
        
    },[props.data.request])
    return(
        <div style={{padding: '20px', overflow: 'auto', height: '100%'}}>
            {showmsg && <Typography style={{fontSize: '14px', color: msgcolor ? 'var(--GreenBaseColor)' : 'var(--RedBaseColor)', fontWeight: 500, marginBottom: '15px'}}> {msg} </Typography>}
            <TextField
                id="username"
                label={ <Typography style={{fontSize: 20, fontWeight: 500, color: "var(--PrimaryText)"}}> User Name </Typography> }
                variant="standard"
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                      </InputAdornment>
                    ),
                    style: {
                        color: "var(--PrimaryText)"
                    },
                }}
                sx={{
                    width: '100%', 
                    marginBottom: '20px', 
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "var(--PrimaryText)",
                    },
                    '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" },
                    //'& .MuiInput-underline:after': { borderBottomColor: 'orange' },
                   
                }}
                value={username}
                onChange={handleusernamechange}
            />
            <TextField
                id="Email"
                label={ <Typography style={{fontSize: 20, fontWeight: 500, color: "var(--PrimaryText)"}}> Email </Typography> }
                variant="standard"
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                      </InputAdornment>
                    ),
                    style: {
                        color: "var(--PrimaryText)",
                        
                    }
                }}
                sx={{width: '100%', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                value={email}
                onChange={handleemailchange}
            />
            <TextField
                id="mobile"
                label={ <Typography style={{fontSize: 20, fontWeight: 500, color: "var(--PrimaryText)"}}> Mobile </Typography> }
                variant="standard"
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                      </InputAdornment>
                    ),
                    style: {
                        color: "var(--PrimaryText)"
                    }
                }}
                sx={{width: '100%', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                value={mobile}
                onChange={handlemobilechnage}
            />
            <TextField
                id="place"
                label={ <Typography style={{fontSize: 20, fontWeight: 500, color: "var(--PrimaryText)"}}> Place </Typography> }
                variant="standard"
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                      </InputAdornment>
                    ),
                    style: {
                        color: "var(--PrimaryText)"
                    }
                }}
                sx={{width: '100%', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                value={place}
                onChange={handleplacechange}
            />
            <TextField
                id="state"
                label={ <Typography style={{fontSize: 20, fontWeight: 500, color: "var(--PrimaryText)"}}> State </Typography> }
                variant="standard"
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                      </InputAdornment>
                    ),
                    style: {
                        color: "var(--PrimaryText)"
                    }
                }}
                sx={{width: '100%', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                value={state}
                onChange={handlestatechange}
            />
            <TextField
                id="country"
                label={ <Typography style={{fontSize: 20, fontWeight: 500, color: "var(--PrimaryText)"}}> Country </Typography> }
                variant="standard"
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                      </InputAdornment>
                    ),
                    style: {
                        color: "var(--PrimaryText)"
                    }
                }}
                sx={{width: '100%', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                value={country}
                onChange={handlecountrychange}
            />
            <TextField
                id="pincode"
                label={ <Typography style={{fontSize: 20, fontWeight: 500, color: "var(--PrimaryText)"}}> Pincode </Typography> }
                variant="standard"
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                      </InputAdornment>
                    ),
                    style: {
                        color: "var(--PrimaryText)"
                    }
                }}
                sx={{width: '100%', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                value={pin}
                onChange={handlepinchange}
            />
            <TextField
                id="discription"
                label={ <Typography style={{fontSize: 20, fontWeight: 500, color: "var(--PrimaryText)"}}> Discription </Typography> }
                variant="standard"
                InputProps={{
                    startAdornment: (
                    <InputAdornment position="start">
                    </InputAdornment>
                    ),
                    style: {
                        color: "var(--PrimaryText)"
                    }
                }}
                sx={{width: '100%', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                value={discription}
                onChange={handlediscriptionchane}
            />
            <TextField
                id="usergroup"
                label={ <Typography style={{fontSize: 20, fontWeight: 500, color: "var(--PrimaryText)"}}> User Group </Typography> }
                variant="standard"
                InputProps={{
                    startAdornment: (
                    <InputAdornment position="start">
                    </InputAdornment>
                    ),
                    style: {
                        color: "var(--PrimaryText)"
                    }
                }}
                sx={{width: '100%', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                value={userGroup}
                onChange={handleusergroupchange}
            />
            <TextField
                id="userpermissions"
                label={ <Typography style={{fontSize: 20, fontWeight: 500, color: "var(--PrimaryText)"}}> User Permissions </Typography> }
                variant="standard"
                InputProps={{
                    startAdornment: (
                    <InputAdornment position="start">
                    </InputAdornment>
                    ),
                    style: {
                        color: "var(--PrimaryText)"
                    }
                }}
                sx={{width: '100%', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                value={userpermission}
                onChange={handleuserpermissionchange}
            />
        </div>
    )
}